import { SvgIcon } from '@mui/material';
import React, { ReactElement } from 'react';

export interface VisibilityOffIconProps {}

export const VisibilityOffIcon = (
  _props: VisibilityOffIconProps,
): ReactElement => {
  return (
    <SvgIcon style={{ fontSize: '1em' }} viewBox="0 0 20 16.875">
      <path
        d="M12.25,8.25a4.319,4.319,0,0,1,4.375,4.375c0,.576-.418.745-.625,1.25L19.125,17a11.143,11.143,0,0,0,3.125-4.375,10.991,10.991,0,0,0-10-6.875,11.733,11.733,0,0,0-3.75.625L10.375,8.25A5.83,5.83,0,0,1,12.25,8.25ZM2.875,5.75l2.5,1.875V8.25A9.811,9.811,0,0,0,2.25,12.625c1.547,3.9,5.522,6.25,10,6.25A9.686,9.686,0,0,0,16,18.25l.625.625,2.5,2.5,1.25-1.25L4.125,4.5Zm5,5L9.75,12c-.044.185-.625.432-.625.625,0,1.472,1.64,2.5,3.125,2.5a2.97,2.97,0,0,0,.625,0l1.25,1.25A4.2,4.2,0,0,1,12.25,17a4.319,4.319,0,0,1-4.375-4.375C7.875,11.931,7.581,11.348,7.875,10.75Zm4.375-.625,2.5,2.5h0a2.385,2.385,0,0,0-2.5-2.5Z"
        transform="translate(-2.25 -4.5)"
        fill="currentColor"
      />
    </SvgIcon>
  );
};
